// Custom carousel header - Luke - 21/10/2026
(() => {
  const KEY = "__oenumCarouselTheme";
  window[KEY]?.destroy();

  const STATIC_CONFIG = {
    caption: "OWNERS",
    rating: "4.5",
    count: 125,
    description:
      "Real owners, real cars. Here's what people who park under an Oenum cover every day told us."
  };

  let observer;
  let frame = 0;

  function setText(element, text) {
    if (element.textContent !== text) {
      element.textContent = text;
    }
  }

  function create(tag, className, text = "") {
    const element = document.createElement(tag);
    element.className = className;
    element.textContent = text;
    return element;
  }

  function enhance() {
    const main = document.querySelector("main");
    const heading = main?.querySelector(
      ".AirReviews-CarouselWrapper .AirReviews-Carousel__Heading"
    );
    const title = heading?.querySelector(
      ":scope > .AirReviews-Carousel__Header"
    );

    if (!title) return;

    let caption = heading.querySelector(":scope > .oenum-carousel-caption");
    if (!caption) {
      caption = create("div", "oenum-carousel-caption");
      title.before(caption);
    }
    setText(caption, STATIC_CONFIG.caption);

    let summary = heading.querySelector(":scope > .oenum-carousel-summary");
    if (!summary) {
      summary = create("div", "oenum-carousel-summary");

      const stars = create("span", "oenum-carousel-stars", "★★★★★");
      stars.setAttribute("aria-hidden", "true");

      const stats = create("span", "oenum-carousel-stats");
      summary.append(stars, document.createTextNode(" "), stats);
      title.after(summary);
    }

    const stats = summary.querySelector(".oenum-carousel-stats");
    if (stats) {
      setText(
        stats,
        `${STATIC_CONFIG.rating}/5 | ${STATIC_CONFIG.count} reviews`
      );
    }

    let description = heading.querySelector(
      ":scope > .oenum-carousel-description"
    );
    if (!description) {
      description = create("p", "oenum-carousel-description");
      heading.append(description);
    }
    setText(description, STATIC_CONFIG.description);
  }

  function schedule() {
    if (frame) return;

    frame = requestAnimationFrame(() => {
      frame = 0;
      enhance();
    });
  }

  function connect() {
    observer?.disconnect();

    const main = document.querySelector("main");
    if (!main) return;

    observer = new MutationObserver(schedule);
    observer.observe(main, {
      childList: true,
      subtree: true
    });

    schedule();
  }

  const controller = {
    destroy() {
      observer?.disconnect();
      cancelAnimationFrame(frame);
      document.removeEventListener("DOMContentLoaded", connect);
      document.removeEventListener("shopify:section:load", connect);

      if (window[KEY] === controller) {
        delete window[KEY];
      }
    }
  };

  window[KEY] = controller;

  document.addEventListener("shopify:section:load", connect);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", connect, { once: true });
  } else {
    connect();
  }
})();


(() => {
  window.__oenumHeadingCleanup?.();

  const selector =
    '.AirReviews-CarouselWrapper div.AirReviews-Carousel__Header';

  let observer;
  let frame = 0;
  let root;

  function convert() {
    frame = 0;

    root.querySelectorAll(selector).forEach(element => {
      const heading = document.createElement('h2');

      for (const { name, value } of element.attributes) {
        heading.setAttribute(name, value);
      }

      // Giữ nguyên các node con, không tạo lại bằng innerHTML.
      while (element.firstChild) {
        heading.appendChild(element.firstChild);
      }

      element.replaceWith(heading);
    });
  }

  function schedule() {
    if (!frame) frame = requestAnimationFrame(convert);
  }

  function start() {
    observer?.disconnect();
    root = document.querySelector('main') || document.body;

    observer = new MutationObserver(schedule);
    observer.observe(root, {
      childList: true,
      subtree: true
    });

    schedule();
  }

  window.__oenumHeadingCleanup = () => {
    observer?.disconnect();
    cancelAnimationFrame(frame);
    document.removeEventListener('DOMContentLoaded', start);
    document.removeEventListener('shopify:section:load', start);
  };

  document.addEventListener('shopify:section:load', start);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();